import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const STORAGE_KEY = "lex_polaris_disclaimer_accepted_v1";

export default function DisclaimerModal() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const accepted = window.localStorage.getItem(STORAGE_KEY);
    if (!accepted) setOpen(true);
  }, []);

  if (!open) return null;

  const accept = () => {
    window.localStorage.setItem(STORAGE_KEY, "1");
    setOpen(false);
  };

  const exit = () => {
    window.location.href = "https://www.google.com";
  };

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-deep-ink/85 backdrop-blur-sm px-4 py-8 overflow-y-auto"
      data-testid="disclaimer-modal-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="disclaimer-title"
    >
      <div
        className="bg-ivory text-charcoal w-full max-w-2xl border border-soft-grey shadow-2xl"
        data-testid="disclaimer-modal"
      >
        <div className="px-8 md:px-12 py-10 md:py-14">
          <div className="overline mb-5">Important Notice</div>
          <h2
            id="disclaimer-title"
            className="font-serif text-3xl md:text-4xl font-light leading-tight tracking-tight mb-6"
          >
            Disclaimer & Confirmation
          </h2>
          <div className="space-y-4 text-sm md:text-[15px] leading-relaxed text-charcoal/85 max-h-[40vh] overflow-y-auto pr-2">
            <p>
              As per the rules of the Bar Council of India, Lex Polaris, Advocates &amp; Solicitors is not
              permitted to advertise or solicit work through this website.
            </p>
            <p>
              By clicking &ldquo;I Agree&rdquo;, you acknowledge that you are visiting this website voluntarily for
              general information purposes only. The information available on this website does not constitute
              legal advice, solicitation, advertisement, or an invitation to create a lawyer-client relationship.
            </p>
            <p>
              Any information provided through this website should not be acted upon without seeking professional
              legal advice based on the specific facts and circumstances of your matter.
            </p>
            <p>
              Submission of any enquiry form or communication through this website does not create a
              lawyer-client relationship unless formally accepted by Lex Polaris, Advocates &amp; Solicitors.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-3 mt-10">
            <button
              type="button"
              onClick={accept}
              className="btn-primary flex-1"
              data-testid="disclaimer-agree-btn"
            >
              I Agree
            </button>
            <button
              type="button"
              onClick={exit}
              className="btn-outline flex-1"
              data-testid="disclaimer-exit-btn"
            >
              Exit
            </button>
          </div>

          <div className="mt-8 pt-6 border-t border-soft-grey flex flex-wrap gap-x-6 gap-y-2 text-xs tracking-[0.18em] uppercase text-charcoal/60">
            <Link
              to="/privacy"
              onClick={accept}
              className="hover:text-navy transition-colors"
              data-testid="disclaimer-link-privacy"
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms"
              onClick={accept}
              className="hover:text-navy transition-colors"
              data-testid="disclaimer-link-terms"
            >
              Terms of Use
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
